import { ReactNode } from 'react';

export enum DataTestId {
    CurrencySelectDialogSelectionCard = 'currency-select-dialog-selection-card',
}

export interface Currency {
    code: string;
    symbol: string;
    description: string | null;
}

export interface CurrencySelectDialogTexts {
    dialogTitle: ReactNode;
    suggestedCurrenciesTitle: string;
    otherCurrenciesTitle: string;
    propertyCurrencyLabel: string;
    searchInputPlaceholder: string;
    searchInputAriaLabel: string;
    filteredCurrenciesAriaLabel: string;
    filteredCurrenciesEmptyStatePrimary: string;
    filteredCurrenciesEmptyStateSecondary: string;
    suggestedCurrenciesAriaLabel: string;
    otherCurrenciesAriaLabel: string;
    getFilteredCountForScreenReadersText?: (count: number) => string;
}
